import * as React from 'react';
import { Form, Formik } from 'formik';
import { SchoolEvent } from 'Src/models/event';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import { ReportActions, ReportDescription, ReportSection, ReportToggle, ReportToggleList } from '../ReportFormUi';
import '../../SchoolEventView.scss';

interface Props {
  event: SchoolEvent;
  activeSchoolId: string;
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
}

//report 043
export function CautionsDismissalsReportForm({ onCloseClick, onSubmit, event, activeSchoolId }: Props) {
  const requestInitial = {
    isPrintFullNames: true,
    isPrintComments: true
  };

  return (
    <Formik
      onSubmit={values => onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.CAUTIONS_DISMISSALS)}
      initialValues={requestInitial}
    >
      {({ values, setFieldValue }) => (
        <Form className="eReportForm">
          <ReportDescription>
            Get your own pre-filled form to keep record of players cautions and dismissals.
          </ReportDescription>

          <ReportSection
            number={1}
            title="Include in the report"
            hint="Choose which details should appear in the generated document."
          >
            <ReportToggleList>
              <ReportToggle
                name="isPrintFullNames"
                label="Show full names"
                hint="Otherwise only the first name and surname initial will be shown. Opposing team full names are still hidden for inter-school fixtures."
                value={values.isPrintFullNames}
                onChange={value => setFieldValue('isPrintFullNames', value)}
              />
              <ReportToggle
                name="isPrintComments"
                label="Keep space for comments"
                hint="Adds an extra column for notes related to each student."
                value={values.isPrintComments}
                onChange={value => setFieldValue('isPrintComments', value)}
              />
            </ReportToggleList>
          </ReportSection>

          <ReportActions onCancel={onCloseClick} />
        </Form>
      )}
    </Formik>
  );
}
